import type { messageBoxIcon } from "@/.shared/components/dialogs/message-box";

export type AvailableButtons = 'primary_vals' | 'secondary_vals' | 'only_changed' | 'vector' | 'spectr' | 'sym' | 'freq' | 'calc' | 'zoom_button' 
| 'pan_button' | 'reset_button' | 'csv' | 'settings';

export type FrequencyDialogResult = {result: 'ok' | 'cancel', signal: number | null};
export type SymmetricalDialogResult = {
    result: 'ok' | 'cancel', 
    firstSignal: number | null,
    secondSignal: number | null,
    thirdSignal: number | null,
    components0: SymmetricalDialogResultComponent,
    components1: Omit<SymmetricalDialogResultComponent, "instantValues">,
    components2: Omit<SymmetricalDialogResultComponent, "instantValues">
};

type SymmetricalDialogResultComponent = {
    absoluteValue: boolean,
    phase: boolean,
    instantValues: boolean
}



export type CalculatedSignalDialogResult = {
    result: 'ok' | 'cancel', 
    expression: CalculatedSignalDialogResultExpression;
    param1 : number;
    param2 : number;
    components: CalculatedSignalDialogResultComponent;
}

export type CalculatedSignalDialogResultExpression = "sum_signals" | "subtract_signals" | "multiplication_by_coef";

type CalculatedSignalDialogResultComponent = {
    absoluteValue: boolean,
    phase: boolean,
    instantValues: boolean
}


export type OscilosWrapperMethods = { 
    enableButton:  ((buttonId: AvailableButtons) => void), 
    disableButton:  ((buttonId: AvailableButtons) => void) 
    setOnClick: ((buttonId: AvailableButtons, onClick: () => void) => void)
    isActive :  ((buttonId: AvailableButtons) => boolean), 
    setActive :  ((buttonId: AvailableButtons, active: boolean) => void), 
    alert: (message: string, icon?: messageBoxIcon) => void,
    openFrequencyDialog: (signals: string[]) => Promise<FrequencyDialogResult>,
    openSymmetricalDialog: (signals: string[]) => Promise<SymmetricalDialogResult>,
    openCalculatedDialog: (signals: {name: string, isPeriodic:boolean}[]) => Promise<CalculatedSignalDialogResult>,
    openSettingsDialog: () => Promise<SettingsDialogResult>,
    showSpinner: () => void,
    hideSpinner: () => void,
};

export type PlotSpectrumOptions = {
    signal: number,
    intervalStart: number,
    intervalEnd: number,
}

export type SettingsDialogResult =  {
    result: 'ok' | 'cancel', 
    analogSignalsVisibility: boolean[],
    discreteSignalsVisibility: boolean[],
}

export type OscLibOptions = {
    translate: (key: string) => string,
}

function getOscData() {
    return osc_data;
}

declare function load_osc_files(files: File[]): void;
declare function osc(options: OscLibOptions) : void;
declare function osc_set_methods(methods: null | OscilosWrapperMethods) : void;
declare let osc_data: any;
declare function disp_primary_values(data: any) : void;
declare function disp_secondary_values(data: any) : void;
declare function disp_change(data: any) : void;
declare function disp_vector(data: any) : void;
declare function disp_freq(data: any) : void;
declare function disp_sym(data: any) : void;
declare function disp_calc(data: any) : void;
declare function zoom_axes() : void;
declare function pan_axes() : void;
declare function reset_axes() : void;
declare function plot_spectr(options : PlotSpectrumOptions) : void;
declare function settings(data: any) : void;
declare function save_csv(data: any) : void;

export default {
    load_osc_files,
    osc,
    osc_set_methods,
    getOscData,
    disp_primary_values,
    disp_secondary_values,
    disp_change,
    disp_vector,
    disp_freq,
    disp_sym,
    disp_calc,
    zoom_axes,
    pan_axes,
    reset_axes,
    plot_spectr,
    settings,
    save_csv
}
